/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/ActionsAction/Edit/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let editSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit',
})
let editIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 marginLeft={dtSpaceXs}
 type="primary"
 data="edit"
 onClick={editSubmitData}
 disabled={editIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}